var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.88 27.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ee7404;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.01,0c.42,.12,.87,.2,1.26,.38,1.66,.78,2.57,2.11,2.59,3.95,.03,3.57,.01,7.15,0,10.72,0,.68-.46,1.17-1.1,1.17-.63,0-1.08-.49-1.08-1.18,0-3.54,0-7.08,0-10.62,0-1.16-.75-2.04-1.87-2.22-.14-.02-.29-.02-.43-.02-6.3,0-12.59,0-18.89,0-1.4,0-2.32,.92-2.32,2.32,0,6.29,0,12.58,0,18.86,0,1.42,.91,2.34,2.33,2.34,3.63,0,7.26,0,10.89,0,.14,0,.27,0,.41,.03,.55,.12,.91,.61,.86,1.16-.05,.55-.51,.98-1.08,.99-1.19,0-2.38,0-3.57,0-2.5,0-5.01,0-7.51,0-2.32,0-4.06-1.47-4.45-3.77,0-.03-.03-.06-.04-.1,0-6.71,0-13.43,0-20.14,.02-.05,.04-.1,.05-.15C.39,1.87,1.47,.68,3.26,.14c.2-.06,.4-.09,.6-.14,6.71,0,13.43,0,20.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.65,8.33c-1.55,0-3.1,0-4.65,0-.78,0-1.3-.72-1.06-1.44,.15-.45,.56-.73,1.06-.74,1.17,0,2.34,0,3.51,0,1.92,0,3.84,0,5.77,0,.8,0,1.33,.71,1.08,1.44-.15,.46-.56,.74-1.09,.74-1.54,0-3.08,0-4.62,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.66,14.86c-1.56,0-3.12,0-4.68,0-.53,0-.94-.34-1.07-.84-.11-.46,.09-.96,.52-1.18,.17-.09,.38-.15,.57-.15,3.1,0,6.2,0,9.3,0,.64,0,1.12,.47,1.12,1.08,0,.61-.48,1.09-1.11,1.09-1.55,0-3.1,0-4.65,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.75,21.77c-.26,0-.53,0-.79,0-.6-.02-1.07-.49-1.07-1.08,0-.6,.47-1.09,1.08-1.1,.52,0,1.03,0,1.55,0,.6,.01,1.07,.49,1.07,1.08,0,.6-.47,1.08-1.08,1.1-.25,0-.51,0-.76,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.07,8.33c-.18,0-.36,0-.54,0-.61-.02-1.09-.49-1.08-1.09,0-.6,.48-1.07,1.1-1.08,.36,0,.72,0,1.09,0,.62,.01,1.09,.49,1.08,1.09,0,.59-.47,1.06-1.07,1.08-.19,0-.38,0-.57,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.07,14.86c-.19,0-.38,0-.57,0-.6-.02-1.06-.5-1.06-1.09,0-.59,.47-1.07,1.07-1.08,.38,0,.76-.01,1.14,0,.6,.02,1.06,.5,1.06,1.09,0,.58-.46,1.05-1.04,1.08-.2,0-.4,0-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.08,21.77c-.19,0-.38,0-.57,0-.6-.02-1.06-.5-1.06-1.09,0-.59,.46-1.07,1.06-1.08,.38,0,.76-.01,1.14,0,.6,.02,1.06,.5,1.06,1.09,0,.59-.46,1.06-1.06,1.09-.19,0-.38,0-.57,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.17,19.03h-1.38v-1.08h3.27v3.27h-1.09v-1.37c-1.65,1.65-3.27,3.28-4.9,4.9-.57-.57-1.11-1.12-1.66-1.66-.86,.86-1.69,1.69-2.51,2.51-.27-.27-.52-.52-.76-.76,1.06-1.06,2.15-2.15,3.25-3.25,.53,.53,1.07,1.07,1.6,1.6,1.39-1.39,2.76-2.77,4.16-4.16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart1);
export default __webpack_public_path__ + "static/media/chart1.967183c95bd16a17b24f9855b2ebd18c.svg";
export { ForwardRef as ReactComponent };